import React from "react";
import { Field, reduxForm } from "redux-form";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
import FormHelperText from "@material-ui/core/FormHelperText";
import { ToastContainer, toast } from "react-toastify";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import InputLabel from "@material-ui/core/InputLabel";
import { Typography, styled } from "@material-ui/core";
import "react-toastify/dist/ReactToastify.css";
import { RemoveShoppingCartSharp } from "@material-ui/icons";
import { ADMIN_MSGS } from "../../../Constant/Messages";
import CloudUploadIcon from "@material-ui/icons/CloudUpload";

const renderTextField = ({
  input,
  label,
  meta: { touched, error },
  ...custom
}) => (
  <TextField
    margin="normal"
    fullWidth
    label={label}
    //   autoFocus
    error={touched && error}
    helperText={error}
    {...input}
    {...custom}
    InputLabelProps={{
      style: {
        color: "black",
        fontFamily: "GT-Walsheim-medium",
        fontSize: "14px",
      },
    }}
  />
);
// const renderImage = ({ input, label, meta: { touched, error }, ...custom }) => (
//   <div>
//     <label htmlFor="contained-button-file">
//       <Button
//         variant="contained"
//         color="primary"
//         component="span"
//         startIcon={<CloudUploadIcon />}
//         onChange={(e) => input.onChange(e.target.files[0])}
//         style={{ backgroundColor: "#4f2d7f", marginTop: "1.5rem" }}
//         onClick={(e) => this .onUploadButton}
//       >
//         Upload Image
//       </Button>
//       {touched && error && <span>{error}</span>}
//     </label>
//   </div>
// );
const renderDropDown = ({
  input,
  label,
  props,
  meta: { touched, error },
  ...custom
}) => (
  <FormControl style={{ width: "100%", marginTop: "25px" }}>
    <InputLabel
      id="demo-simple-select-autowidth-label"
      style={{
        fontFamily: "GT-Walsheim-medium",
        fontSize: "14px",
        color: "black",
      }}
    >
      {label || "Role *"}
    </InputLabel>
    <Select
      labelId="demo-simple-select-helper-label"
      id="demo-simple-select-error"
      // value={age}
      label={label}
      autoFocus
      error={touched && error}
      helperText={error}
      {...input}
      {...custom}
      InputLabelProps={{
        style: {
          color: "black",
          fontFamily: "GT-Walsheim-medium",
          fontSize: "14px",
        },
      }}
    >
      {custom.names.map((name, index) => (
        <MenuItem key={index} value={name.id}>
          {name.name}
        </MenuItem>
      ))}
    </Select>
    <FormHelperText style={{ color: "red" }}>{error}</FormHelperText>
  </FormControl>
);




const regex = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[a-zA-Z\d@$.!%*#?&]/;
const testEmail = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;

const numberRegex = /^[0-9]+$/;
const alphabetRegex = /^[A-Za-z]+$/;

const validate = (values) => {
  const errors = {};
  console.log("inside Validate :: ", values);
  const requiredFields = [
    "group",
    "cname",
    "c_email",
    "c_partner",
    "p_email",
    "rep_name",
    "rep_email",
    "panNumber",
    "isAuditClient",
  ];
  requiredFields.forEach((field) => {
    if (field == "rep_email" && !testEmail.test(values[field])) {
      errors[field] = "Enter Valid Email";
    }
    if (!values[field]) {
      errors[field] = "Required";
    }
  });

  if (values.password && values.password.length < 8) {
    errors.password = ADMIN_MSGS.PASSWORD_MIN_LENGTH;
  } else if (values.password && values.password.length > 20) {
    errors.password = ADMIN_MSGS.PASSWORD_MAX_LENGTH;
  } else if (values.password && !regex.test(values.password)) {
    errors.password = ADMIN_MSGS.PASSWORD_SPECIAL_CHAR;
  }

  if (numberRegex.test(values.cname)) {
    errors.cname = ADMIN_MSGS.COMPANY_NAME_ALPHANUMERIC;
  }
  if (values.panNumber?.length != 10) {
    errors.panNumber = ADMIN_MSGS.PAN_INVALID;
  }
  if (
    numberRegex.test(values.panNumber) ||
    alphabetRegex.test(values.panNumber)
  ) {
    errors.panNumber = ADMIN_MSGS.PAN_INVALID;
  }
  if (!alphabetRegex.test(values.rep_name)) {
    errors.rep_name = ADMIN_MSGS.REP_NAME_INVALID;
  }

  return errors;
};


class Register_Company extends React.Component {
  constructor(props) {
    super(props);
    this.onUploadButton = this.onUploadButton.bind(this);
    this.onFileSelected = this.onFileSelected.bind(this);
    this.handleData = this.handleData.bind(this);
    this.state = {
      firstName: "",
      lastName: "",
      email: "",
      password: "",
      role: "",
      companyName: "",
      create_company_button: true,
      uploadImage: "",
      // register_company: false
    };
  }
  async onUploadButton() {
    await this.refs.fileUploader.click();
  }
  async onFileSelected(event) {
    console.log("FileSelected: ", event, event.target);
    await this.setState({
      uploadImage: event.target.files[0],
      loading: true,
    });
  }
  async handleData(data) {
    console.log("handleData: ", this.state.uploadImage, data);
    this.props.onSubmit(data, this.state.uploadImage);
  }
  render() {
    console.log("group lis in company",this.props.groups)
    let rolesName = [
      {
        id: 1,
        name: "Yes",
      },
      {
        id: 2,
        name: "No",
      },
    ];

    const { handleSubmit } = this.props;

    return (
      <div style={{ width: "100%" }} id="CreateUser">
        <input
          accept="image/*"
          //className={classes.input}
          style={{ display: "none" }}
          // id="contained-button-file"
          multiple
          name="upfile"
          type="file"
          ref={"fileUploader"}
          onChange={this.onFileSelected}
          onClick={(event) => {
            event.target.value = null;
          }}
        />

        <form
          style={{ width: "100%", paddingBottom: "5%" }}
          onSubmit={handleSubmit(this.handleData)}
        >
          <div class="row">
            <div class="col-md-6">
              <Field
                name="group"
                component={renderDropDown}
                label="Group Name *"
                style={{ paddingTop: "6%" }}
                names={this.props.groups}
              />
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <Field
                name="cname"
                component={renderTextField}
                label="Entity Name *"
                style={{ paddingTop: "6%" }}
              />
            </div>
            <div class="col-md-6">
              <Field
                name="panNumber"
                component={renderTextField}
                label="Pan Number *"
                style={{ paddingTop: "6%" }}
              />
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <Field
                name="isAuditClient"
                component={renderDropDown}
                label="Audit Client *"
                names={rolesName}
              />
            </div>
            <div class="col-md-6">
              <Field
                name="rep_name"
                component={renderTextField}
                label="Representative Name *"
                style={{ paddingTop: "6%" }}
              />
            </div>
          </div>
          <div class="row">
            <div className="col-md-6">
              <Field
                name="rep_email"
                component={renderTextField}
                label="Representative Email *"
                style={{ paddingTop: "6%" }}
              />
            </div>
            <div class="col-md-6">
              <Button
                variant="contained"
                color="primary"
                component="span"
                startIcon={<CloudUploadIcon />}
                style={{ backgroundColor: "#4f2d7f", marginTop: "1.5rem" }}
                onClick={this.onUploadButton}
              >
                Upload Image
              </Button>
            </div>
          </div>

          <div className={"d-flex justify-content-center align-items-center"}>
            <Button
              type="submit"
              variant="contained"
              color="primary"
              style={{
                backgroundColor: "#4f2d7f",
                color: "white",
                marginTop: "15px",
              }}
            >
              Submit
            </Button>
          </div>
        </form>
      </div>
    );
  }
}
export default reduxForm({
  form: "Register_Company",
  validate,
})(Register_Company);
